// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1cAkE","header":"PatientQuestionnaire_header__t7auM","info":"PatientQuestionnaire_info__10dKR"};